// extracted by mini-css-extract-plugin
module.exports = {"svg":"progress-ring_WuZA2","isResetting":"progress-ring_15ZlI"};